// declare defined variables one time in one place
// https://github.com/TypeStrong/ts-loader/issues/37#issuecomment-381375624

declare const REVISION: string;
declare const PLATFORM: string;

const _REVISION = REVISION;
const _PLATFORM = PLATFORM;

export { _REVISION as REVISION };
export { _PLATFORM as PLATFORM };
